import rule from './doingCreate_security_profile_reset';

export default {
    ...rule,
    verb: 'doingUpdate'
};